import { useTranslation } from "@msuite/ui/localization";
import { Tag } from "@msuite/ui/tag";
import { Tooltip } from "@msuite/ui/tooltip";
import { guardString } from "@msuite/utils/strings";
import { formatInvoiceAmount } from "@/components/incoming-invoices";
import type { OffsetRow } from "./to-offset-rows";

/** Props Interface */
interface OffsetAppliedCellProps {
	row: OffsetRow;
}

/** What a picked outgoing invoice takes off the payment, or that the payment is covered before it. */
export function OffsetAppliedCell({ row }: OffsetAppliedCellProps) {
	/** Context */
	const { t } = useTranslation();

	/** Guard */
	if (row.isUnused) {
		return (
			<Tooltip label={t("incoming_invoices.payments.offsets.not_reached_hint")}>
				<Tag
					size="xs"
					color="amber"
					variant="plain"
				>
					{t("incoming_invoices.payments.offsets.not_reached")}
				</Tag>
			</Tooltip>
		);
	}
	if (row.appliedAmount === null) return guardString(null);

	/** Render */
	return formatInvoiceAmount(row.appliedAmount, "EUR");
}
